var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center align-center justify-center fill-height"},[_c('v-col',{staticClass:"mb-4"},[_c('h1',{staticClass:"display-2 font-weight-bold mb-3"},[_vm._v(" Bienvenido al sistema de WI PLANNING ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }